(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-cable-product"]) return;
  try {
    
if (!customElements.get('cp-cable-product')) customElements.define('cp-cable-product', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.$ = selector => this.querySelector(selector);
    this.variants = JSON.parse(this.$('[data-variants]').textContent).filter(v => v.feet > 0).map(v => ({...v, key: String(v.id), units: 1}));
    this.tiers = (this.dataset.tiers || '').split(',').filter(Boolean).map(t => t.split(':').map(Number));
    const foot = this.variants.find(v => v.feet === 1);
    if (foot) this.tiers.forEach(([feet]) => this.variants.push({...foot, key: `${foot.id}-${feet}`, title: `${feet} ft`, feet, units: feet}));
    this.copy = JSON.parse(this.$('[data-copy]').textContent);
    this.format = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'});
    this.selected = this.variants.find(v => v.key === this.$('[name="id"]').value) || this.variants[0];
    if (!this.selected) { this.$('[data-error]').textContent = this.copy.setup; return; }
    this.defaultImage = this.$('[data-product-image] img')?.src;
    this.querySelectorAll('input[type="radio"]').forEach(radio => radio.addEventListener('change', () => {
      this.selected = this.variants.find(v => v.key === radio.value);
      this.$('[data-quantity]').value = this.start(this.selected);
      const url = new URL(location.href); url.searchParams.set('variant',this.selected.id); history.replaceState({},'',url);
      this.$('[data-error]').textContent = '';
      this.render();
    }));
    this.$('[data-quantity]').value = this.start(this.selected);
    this.$('[data-quantity]').addEventListener('input', () => { this.follow(); this.render(); });
    this.$('[data-cable-form]').addEventListener('submit', event => this.add(event));
    this.render();
  }
  // ponytail: volume rolls (units>1) are the 1 ft variant, so their quantity is counted in feet: min = roll length, any foot above it (600 ft gets the 500 ft tier)
  start(v){return v.units>1 ? v.units : (v.feet===1 ? 100 : 1);}
  // ponytail: on a volume product the box takes any length from 100 ft and the choice follows the feet typed (499 -> cut to length, 600 -> 500 ft, 1100 -> 1000 ft), so a roll can be lowered
  follow(){const foot=this.tiers.length ? this.variants.find(v=>v.units===1 && v.feet===1) : null, q=Number(this.$('[data-quantity]').value);if(!foot || !(q>=100)) return;this.selected=this.variants.filter(v=>v.id===foot.id && v.units<=q).reduce((a,v)=>v.units>a.units ? v : a,foot);}
  pct(v,feet){return v.dealer ? 0 : this.tiers.reduce((p,[f,r])=>feet>=f ? Math.max(p,r) : p,0);}
  price(v,feet){const p=this.pct(v,feet);return p>v.salePercent ? {now:(v.originalPrice-Math.floor(v.originalPrice*p/100))*v.units,pct:p} : {now:v.price*v.units,pct:v.salePercent};}
  render() {
    const v=this.selected, input=this.$('[data-quantity]'), foot=v.feet===1, vol=v.units>1;
    const volume=this.tiers.length>0 && (foot || vol);
    input.min=volume ? 100 : this.start(v);
    input.step=1;
    const cap=foot && !volume ? 499 : 100000;
    input.max=v.tracked ? Math.min(cap,Math.max(Number(input.min),v.stock)) : cap;
    this.$('[name="id"]').value=v.id;
    this.querySelectorAll('input[type="radio"]').forEach(r=>r.checked=r.value===v.key);
    const q=input.validity.valid && input.value!=='' ? Number(input.value) : 0;
    const ft=vol ? q : v.feet*q;
    // ponytail: on a volume product (1 ft unit + tiers) the headline price is the total for the feet entered; an invalid entry falls back to the choice's minimum
    const live=this.tiers.length>0 && (foot || vol), shown=live ? (ft || this.start(v)) : v.feet;
    const each=this.price(v,shown);
    this.$('[data-price]').textContent=this.format.format(each.now*(live ? shown/v.units : 1)/100);
    this.$('[data-original-price]').hidden=!(each.pct>0 && v.originalPrice>0);
    this.$('[data-original-price]').textContent=this.format.format(v.originalPrice*(live ? shown : v.units)/100);
    this.$('[data-price-unit]').textContent=live ? `${shown.toLocaleString()} ${this.copy.totalFeet}` : (foot ? this.copy.perFoot : this.copy.perRoll);
    this.$('[data-quantity-label]').textContent=foot || vol ? this.copy.feet : this.copy.rolls;
    this.$('[data-limits]').textContent=foot ? this.copy.limits : '';
    this.$('[data-dealer]').hidden=!v.dealer;
    this.$('[data-sku]').textContent=v.sku || '';
    this.$('[data-length-summary]').textContent=`${ft.toLocaleString()} ${this.copy.totalFeet}`;
    this.$('[data-line-total]').textContent=this.format.format(this.price(v,ft).now*(vol ? q/v.units : q)/100);
    const lowStock=v.tracked && v.stock<Number(input.min);
    this.$('[data-add]').disabled=!v.available || lowStock || this.busy || v.price<=0;
    this.$('[data-add]').textContent=v.available && !lowStock ? this.copy.add : this.copy.soldOut;
    this.$('[data-stock]').textContent=lowStock && v.stock>0 ? this.copy.lowStock : (!v.available ? this.copy.soldOut : '');
    this.querySelectorAll('[data-rate]').forEach(row=>row.classList.toggle('is-selected',row.dataset.rate===v.key));
    const img=this.$('[data-product-image] img');
    if(img){img.removeAttribute('srcset');img.src=v.image || this.defaultImage;}
  }
  async add(event) {
    event.preventDefault();
    if(this.busy || !this.$('[data-cable-form]').reportValidity() || this.$('[data-add]').disabled) return;
    const v=this.selected, quantity=Number(this.$('[data-quantity]').value);
    this.busy=true;this.render();this.$('[data-error]').textContent='';
    try {
      const response=await fetch(`${this.dataset.cartUrl}.js`,{headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok) throw new Error(this.copy.error);
      const cart=await response.json();
      const existing=cart.items.filter(item=>item.variant_id===v.id).reduce((sum,item)=>sum+item.quantity,0);
      if(v.feet===1 && (quantity<100 || (!this.tiers.length && existing+quantity>499))) throw new Error(this.copy.cartLimit);
      const added=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:v.id,quantity}]})});
      const result=await added.json();
      if(!added.ok || result.status) throw new Error(typeof result.description==='string' ? result.description : this.copy.error);
      location.assign(this.dataset.cartUrl);
    } catch(error) { this.$('[data-error]').textContent=error.message || this.copy.error; }
    finally {this.busy=false;this.render();}
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-sale-page"]) return;
  try {
    
if(!customElements.get('cp-sale-page'))customElements.define('cp-sale-page',class extends HTMLElement{
 connectedCallback(){this.update=()=>{const start=this.dataset.start?Number(this.dataset.start)*1000:-Infinity,end=this.dataset.end?Number(this.dataset.end)*1000:Infinity,now=Date.now();const active=this.dataset.designMode==='true'||(this.dataset.enabled==='true'&&this.dataset.hasProducts==='true'&&now>=start&&now<end);this.querySelector('[data-sale-content]').hidden=!active;this.querySelector('[data-sale-inactive]').hidden=active;};this.update();this.timer=setInterval(this.update,30000);}
 disconnectedCallback(){clearInterval(this.timer);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist-page"]) return;
  try {
    
  class WishlistView extends HTMLElement {
    constructor() {
      super();
      this.activeListId = null;
      this.isInitialized = false;
    }

    connectedCallback() {
      this.gridViewContainer = this.querySelector('[data-wishlist-items-grid-display]');
      this.wishlistPaginateContainer = document.getElementById('wishlist-paginate');
      this.viewCols = [...this.querySelectorAll('[data-col]')];

      this.wishlistContainer = this.closest('[data-wishlist-container]');
      this.wishlistFooter = document.querySelector('[data-wishlist-footer]');

      // Project List elements
      this.tabsContainer = document.querySelector('[data-list-tabs]');
      this.managementDropdown = document.querySelector('[data-management-dropdown]');
      this.managementTrigger = document.querySelector('[data-management-trigger]');

      this.viewCols.forEach(viewCol => {
        viewCol.addEventListener('click', this.onViewColClick.bind(this));
      });

      window.addEventListener('resize', theme.utils.rafThrottle(this.onResize.bind(this)));

      // Initialize the page
      this.initProjectListPage();
    }

    getMaxColOnSize() {
      const availableViewCols = this.viewCols.filter(view => {
        return getComputedStyle(view, null).getPropertyValue('display') === 'inline-block';
      }).map(view => Number(view.dataset.col));

      return availableViewCols[availableViewCols.length - 1];
    }

    onResize() {
      const selectedColEl = this.querySelector('[data-col].active');
      if (!selectedColEl) return;
      const selectedCol = Number(selectedColEl.dataset.col);
      const maxColNum = this.getMaxColOnSize();

      if (selectedCol > maxColNum) {
        const target = this.viewCols.find(viewCol => Number(viewCol.dataset.col) === maxColNum);
        if (target) target.click();
      }
    }

    onViewColClick(event) {
      const viewCol = event.target;
      const col = Number(viewCol.dataset.col);

      this.switchViewListGrid(col === 1);
      this.setPaginationAndHeadingView(col === 1);
      this.paginationForList(col === 1);
      this.setGridColumns(col);
      this.setActiveViewCol(viewCol);
    }

    switchViewListGrid(isList) {
      if (isList) {
        this.gridViewContainer.classList.add('productList');
        return;
      }

      this.gridViewContainer.classList.remove('productList');
    }

    setGridColumns(col) {
      this.gridViewContainer.style.setProperty('--grid-columns', col);
    }

    setActiveViewCol(colElement) {
      this.viewCols.forEach(col => col.classList.remove('active'));
      colElement.classList.add('active');
    }

    setPaginationAndHeadingView(isList) {
      if (isList) {
        this.wishlistPaginateContainer.style.display = 'flex';
        return;
      }

      this.wishlistPaginateContainer.style.display = 'none';
    }

    paginationForList(isList) {
      const items = this.gridViewContainer.querySelectorAll('.product');
      const currentPage = Number(this.wishlistPaginateContainer.dataset.currentPage);

      if (isList && currentPage) {
        items.forEach((item, index) => {
          if (index >= (currentPage - 1) * 3 && index < currentPage * 3) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      } else {
        items.forEach((item) => {
          item.style.display = '';
        });
      }
    }

    /**
     * Initialize the Project List page with multi-list support
     */
    async initProjectListPage() {
      if (typeof(Storage) === 'undefined') {
        alert('Sorry! No web storage support..');
        return;
      }

      // Wait for ProjectListManager to be available
      await this.waitForProjectListManager();

      const manager = window.projectListManager;
      if (!manager) {
        console.error('[WishlistView] ProjectListManager not available');
        this.showEmptyState('no-lists');
        return;
      }

      // Render list tabs
      this.renderListTabs();

      // Set up event listeners
      this.bindProjectListEvents();

      // Load the active list
      const activeList = manager.getActiveList();
      if (activeList) {
        this.activeListId = activeList.id;
        await this.loadListProducts(activeList);
      } else {
        this.showEmptyState('no-lists');
      }

      this.isInitialized = true;
    }

    /**
     * Wait for ProjectListManager to be initialized
     */
    waitForProjectListManager() {
      return new Promise((resolve) => {
        if (window.projectListManager && window.projectListManager.isInitialized) {
          resolve();
          return;
        }

        let attempts = 0;
        const maxAttempts = 50; // 5 seconds max
        const interval = setInterval(() => {
          attempts++;
          if (window.projectListManager && window.projectListManager.isInitialized) {
            clearInterval(interval);
            resolve();
          } else if (attempts >= maxAttempts) {
            clearInterval(interval);
            console.warn('[WishlistView] Timeout waiting for ProjectListManager');
            resolve();
          }
        }, 100);
      });
    }

    /**
     * Render the list tabs
     */
    renderListTabs() {
      const manager = window.projectListManager;
      if (!manager || !this.tabsContainer) return;

      const lists = manager.getAllLists();
      const activeList = manager.getActiveList();

      this.tabsContainer.innerHTML = '';

      if (lists.length === 0) {
        return;
      }

      lists.forEach(list => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'project-list-tabs__tab';
        tab.dataset.listId = list.id;

        if (activeList && list.id === activeList.id) {
          tab.classList.add('project-list-tabs__tab--active');
          tab.setAttribute('aria-current', 'true');
        }

        const nameSpan = document.createElement('span');
        nameSpan.className = 'project-list-tabs__tab-name';
        nameSpan.textContent = list.name;

        const countSpan = document.createElement('span');
        countSpan.className = 'project-list-tabs__tab-count';
        countSpan.textContent = list.products.length;

        tab.appendChild(nameSpan);
        tab.appendChild(countSpan);

        tab.addEventListener('click', () => this.switchToList(list.id));

        this.tabsContainer.appendChild(tab);
      });

      // Update management dropdown visibility
      this.updateManagementVisibility();
    }

    /**
     * Update visibility of management options based on active list
     */
    updateManagementVisibility() {
      const manager = window.projectListManager;
      if (!manager) return;

      const activeList = manager.getActiveList();
      const managementContainer = document.querySelector('[data-list-management]');
      const deleteBtn = document.querySelector('[data-delete-list]');

      if (!activeList) {
        if (managementContainer) managementContainer.style.display = 'none';
        return;
      }

      if (managementContainer) managementContainer.style.display = '';

      // Show delete option for all lists (including default)
      if (deleteBtn) {
        deleteBtn.style.display = '';
      }
    }

    /**
     * Bind event listeners for project list functionality
     */
    bindProjectListEvents() {
      // Create list button
      const createBtn = document.querySelector('[data-create-list]');
      if (createBtn) {
        createBtn.addEventListener('click', () => this.openCreateModal());
      }

      // Management dropdown toggle
      if (this.managementTrigger) {
        this.managementTrigger.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleManagementDropdown();
        });
      }

      // Rename list button
      const renameBtn = document.querySelector('[data-rename-list]');
      if (renameBtn) {
        renameBtn.addEventListener('click', () => {
          this.closeManagementDropdown();
          this.openRenameModal();
        });
      }

      // Delete list button
      const deleteBtn = document.querySelector('[data-delete-list]');
      if (deleteBtn) {
        deleteBtn.addEventListener('click', () => {
          this.closeManagementDropdown();
          this.openDeleteModal();
        });
      }

      // Close dropdown on outside click
      document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-list-management]')) {
          this.closeManagementDropdown();
        }
      });

      // Export buttons (Email removed - only PDF and CSV available)
      const exportPdfBtn = document.querySelector('[data-export-pdf]');
      const exportCsvBtn = document.querySelector('[data-export-csv]');
      const addAllToCartBtn = document.querySelector('[data-add-all-to-cart]');

      if (exportPdfBtn) {
        exportPdfBtn.addEventListener('click', () => this.exportToPDF());
      }
      if (exportCsvBtn) {
        exportCsvBtn.addEventListener('click', () => this.exportToCSV());
      }
      if (addAllToCartBtn) {
        addAllToCartBtn.addEventListener('click', () => this.addAllToCart());
      }

      // Modal event bindings
      this.bindModalEvents();

      // Listen for project list events
      document.addEventListener('projectlist:product-added', (e) => {
        if (e.detail.listId === this.activeListId) {
          this.setProductForWishlistPage(e.detail.handle);
          this.renderListTabs(); // Update counts
        }
      });

      document.addEventListener('projectlist:product-removed', (e) => {
        if (e.detail.listId === this.activeListId) {
          this.removeItemFromWishlistPage(e.detail.handle);
          this.renderListTabs(); // Update counts
        }
      });

      document.addEventListener('projectlist:created', () => {
        this.renderListTabs();
      });

      document.addEventListener('projectlist:deleted', () => {
        this.renderListTabs();
        const manager = window.projectListManager;
        if (manager) {
          const activeList = manager.getActiveList();
          if (activeList) {
            this.switchToList(activeList.id);
          }
        }
      });

      document.addEventListener('projectlist:renamed', () => {
        this.renderListTabs();
      });

      document.addEventListener('projectlist:active-changed', (e) => {
        const newActiveId = e.detail.listId;
        if (newActiveId !== this.activeListId) {
          this.switchToList(newActiveId);
        }
      });

      // Legacy event support for remove:wishlist-item
      document.addEventListener('remove:wishlist-item', (event) => {
        const handle = event.detail?.handle;
        const productId = event.detail?.productId;
        this.removeItemFromWishlistPage(handle, productId);
        this.renderListTabs(); // Update counts
      });

      // Legacy event support for add:wishlist-item
      // Note: This is kept for backward compatibility but the new projectlist:product-added
      // event should be the primary handler. We add a flag check to prevent duplicates.
      document.addEventListener('add:wishlist-item', async (event) => {
        const handle = event.detail?.handle;
        const listId = event.detail?.listId;

        // If this event includes a listId, it's from the new system and will be
        // handled by projectlist:product-added - skip to prevent duplicates
        if (listId) {
          console.log(`[WishlistView] Skipping legacy handler - new system will handle listId: ${listId}`);
          return;
        }

        // Only process if handle exists and matches active list context
        if (!handle) return;

        // Check if this is a legacy add (no listId) - only add if not already in grid
        const existingProduct = this.gridViewContainer?.querySelector(`[data-product-handle="${handle}"]`);
        if (existingProduct) {
          console.log(`[WishlistView] Legacy handler: product already in grid: ${handle}`);
          return;
        }

        await this.setProductForWishlistPage(handle);
        this.renderListTabs(); // Update counts
      });

      document.addEventListener('update:pagination', this.wishlistPagination.bind(this));
    }

    /**
     * Bind modal event listeners
     */
    bindModalEvents() {
      // Create Modal
      const createModal = document.querySelector('[data-create-modal]');
      const createInput = document.querySelector('[data-create-input]');
      const createConfirm = document.querySelector('[data-create-confirm]');
      const createCloseButtons = document.querySelectorAll('[data-create-modal-close]');
      const createCharCount = createModal?.querySelector('[data-char-count]');

      if (createInput) {
        createInput.addEventListener('input', () => {
          if (createCharCount) {
            createCharCount.textContent = `${createInput.value.length}/50`;
          }
        });
        createInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.handleCreateList();
          }
        });
      }

      if (createConfirm) {
        createConfirm.addEventListener('click', () => this.handleCreateList());
      }

      createCloseButtons.forEach(btn => {
        btn.addEventListener('click', () => this.closeCreateModal());
      });

      // Rename Modal
      const renameModal = document.querySelector('[data-rename-modal]');
      const renameInput = document.querySelector('[data-rename-input]');
      const renameConfirm = document.querySelector('[data-rename-confirm]');
      const renameCloseButtons = document.querySelectorAll('[data-rename-modal-close]');
      const renameCharCount = renameModal?.querySelector('[data-char-count]');

      if (renameInput) {
        renameInput.addEventListener('input', () => {
          if (renameCharCount) {
            renameCharCount.textContent = `${renameInput.value.length}/50`;
          }
        });
        renameInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.handleRenameList();
          }
        });
      }

      if (renameConfirm) {
        renameConfirm.addEventListener('click', () => this.handleRenameList());
      }

      renameCloseButtons.forEach(btn => {
        btn.addEventListener('click', () => this.closeRenameModal());
      });

      // Delete Modal
      const deleteConfirm = document.querySelector('[data-delete-confirm]');
      const deleteCloseButtons = document.querySelectorAll('[data-delete-modal-close]');

      if (deleteConfirm) {
        deleteConfirm.addEventListener('click', () => this.handleDeleteList());
      }

      deleteCloseButtons.forEach(btn => {
        btn.addEventListener('click', () => this.closeDeleteModal());
      });

      // Close modals on Escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeCreateModal();
          this.closeRenameModal();
          this.closeDeleteModal();
        }
      });
    }

    /**
     * Switch to a different list
     */
    async switchToList(listId) {
      const manager = window.projectListManager;
      if (!manager) return;

      // IMPORTANT: Update activeListId BEFORE calling setActiveList to prevent race condition
      // setActiveList dispatches 'projectlist:active-changed' synchronously, and if activeListId
      // isn't updated first, the event listener will trigger another switchToList call
      this.activeListId = listId;

      // Set as active in manager (this dispatches projectlist:active-changed event)
      manager.setActiveList(listId);

      // Update active tab UI
      const tabs = this.tabsContainer?.querySelectorAll('.project-list-tabs__tab');
      tabs?.forEach(tab => {
        if (tab.dataset.listId === listId) {
          tab.classList.add('project-list-tabs__tab--active');
          tab.setAttribute('aria-current', 'true');
        } else {
          tab.classList.remove('project-list-tabs__tab--active');
          tab.removeAttribute('aria-current');
        }
      });

      // Clear current products from grid (preserve structure)
      if (this.gridViewContainer) {
        this.gridViewContainer.innerHTML = '';
        this.gridViewContainer.classList.remove('is-loaded');
      }

      // Load new list's products (this will call hideEmptyState or showEmptyState as needed)
      const list = manager.getList(listId);
      if (list) {
        await this.loadListProducts(list);
      }

      // Update management visibility
      this.updateManagementVisibility();
    }

    /**
     * Restore the grid structure if it was replaced by empty state
     * Note: This rebuilds just the essential grid container without the switcher
     * (switcher is server-rendered and would need a page refresh to restore fully)
     */
    restoreGridStructure() {
      if (!this.wishlistContainer) return;

      // Check if grid container exists
      let gridContainer = this.wishlistContainer.querySelector('[data-wishlist-items-grid-display]');

      if (!gridContainer) {
        // The structure was replaced - restore just the grid container
        // The switcher controls won't work but products will display
        const defaultCol = this.dataset.defaultDesktopCol || 4;

        // Create the minimal structure needed to display products
        const productListing = document.createElement('div');
        productListing.className = 'product-listing';
        productListing.setAttribute('data-wishlist-container', '');

        const gridWrapper = document.createElement('div');
        gridWrapper.className = 'wishlist-items-container product-grid-container';
        gridWrapper.setAttribute('data-default-desktop-col', defaultCol);

        const gridDisplay = document.createElement('div');
        gridDisplay.className = 'wishlist-items-display grid-layout product-grid product-grid--grid';
        gridDisplay.setAttribute('data-wishlist-items-grid-display', '');
        gridDisplay.setAttribute('data-view', defaultCol);
        gridDisplay.style.setProperty('--grid-columns', defaultCol);

        gridWrapper.appendChild(gridDisplay);
        productListing.appendChild(gridWrapper);

        // Clear empty state content and add grid structure
        this.wishlistContainer.innerHTML = '';
        this.wishlistContainer.appendChild(productListing);

        // Re-acquire references
        this.gridViewContainer = gridDisplay;
        this.wishlistContainer = productListing;
      }
    }

    /**
     * Load products for a specific list
     */
    async loadListProducts(list) {
      if (!list || !list.products || list.products.length === 0) {
        this.showEmptyState('empty-list');
        return;
      }

      // Hide empty state and show the grid
      this.hideEmptyState();

      try {
        await Promise.all(list.products.map((handle, index) =>
          this.setProductForWishlistPage(handle, index, list.products.length)
        ));

        if (this.gridViewContainer) {
          this.gridViewContainer.classList.add('is-loaded');
        }

        this.wishlistPagination();
        this.setDefaultLayout();
        this.updateShareWishlistViaMail();
      } catch(err) {
        console.error('[WishlistView] Error loading products:', err);
      }
    }

    /**
     * Show empty state based on type
     * Note: This method now uses show/hide instead of replacing innerHTML
     * to preserve the grid structure for when the user switches lists
     */
    showEmptyState(type = 'empty-list') {
      if (!this.wishlistContainer) return;

      this.wishlistContainer.classList.add('is-empty');

      // Hide the grid container instead of destroying it
      if (this.gridViewContainer) {
        this.gridViewContainer.style.display = 'none';
        this.gridViewContainer.innerHTML = ''; // Clear products
      }

      // Also hide the parent wrapper and switcher
      const wishlistView = this.wishlistContainer.querySelector('wishlist-view');
      const switcherGrid = this.wishlistContainer.querySelector('.switcher-grid');
      if (wishlistView) wishlistView.style.display = 'none';
      if (switcherGrid) switcherGrid.style.display = 'none';

      let message = '';
      let actionText = '';
      let actionUrl = window.routes.collection_all;
      let showCreateButton = false;

      if (type === 'no-lists') {
        message = window.projectList?.no_lists || 'Create your first project list to start saving products';
        actionText = window.projectList?.create_first_list || 'Create your first list';
        showCreateButton = true;
      } else {
        message = window.projectList?.empty_list || 'This project list is empty';
        actionText = window.wishlist?.continue_shopping || 'Continue shopping';
      }

      let actionsHTML = '';
      if (showCreateButton) {
        actionsHTML = `
          <button class="button" type="button" data-create-list-inline>
            ${actionText}
          </button>
        `;
      } else {
        actionsHTML = `
          <a class="button" href="${actionUrl}">
            ${actionText}
          </a>
        `;
      }

      // Check if empty state already exists, create if not
      let emptyStateEl = this.wishlistContainer.querySelector('.wishlist-content-empty');
      if (!emptyStateEl) {
        emptyStateEl = document.createElement('div');
        emptyStateEl.className = 'page-margin wishlist-content-empty center';
        this.wishlistContainer.appendChild(emptyStateEl);
      }

      emptyStateEl.innerHTML = `
        <span class="wishlist-content-text block">${message}</span>
        <div class="wishlist-content-actions">
          ${actionsHTML}
        </div>
      `;
      emptyStateEl.style.display = '';

      // Bind inline create button if shown
      if (showCreateButton) {
        const inlineCreateBtn = emptyStateEl.querySelector('[data-create-list-inline]');
        if (inlineCreateBtn) {
          inlineCreateBtn.addEventListener('click', () => this.openCreateModal());
        }
      }

      if (this.wishlistFooter) {
        this.wishlistFooter.style.display = 'none';
      }
    }

    /**
     * Hide the empty state and show the grid
     */
    hideEmptyState() {
      if (!this.wishlistContainer) return;

      this.wishlistContainer.classList.remove('is-empty');

      // Show the grid container
      if (this.gridViewContainer) {
        this.gridViewContainer.style.display = '';
      }

      // Show the parent wrapper and switcher
      const wishlistView = this.wishlistContainer.querySelector('wishlist-view');
      const switcherGrid = this.wishlistContainer.querySelector('.switcher-grid');
      if (wishlistView) wishlistView.style.display = '';
      if (switcherGrid) switcherGrid.style.display = '';

      // Hide empty state element
      const emptyStateEl = this.wishlistContainer.querySelector('.wishlist-content-empty');
      if (emptyStateEl) {
        emptyStateEl.style.display = 'none';
      }

      if (this.wishlistFooter) {
        this.wishlistFooter.style.display = '';
      }
    }

    /**
     * Toggle management dropdown
     */
    toggleManagementDropdown() {
      const isOpen = this.managementTrigger?.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        this.closeManagementDropdown();
      } else {
        this.openManagementDropdown();
      }
    }

    openManagementDropdown() {
      if (this.managementTrigger) {
        this.managementTrigger.setAttribute('aria-expanded', 'true');
      }
      if (this.managementDropdown) {
        this.managementDropdown.setAttribute('aria-hidden', 'false');
      }
    }

    closeManagementDropdown() {
      if (this.managementTrigger) {
        this.managementTrigger.setAttribute('aria-expanded', 'false');
      }
      if (this.managementDropdown) {
        this.managementDropdown.setAttribute('aria-hidden', 'true');
      }
    }

    /**
     * Modal methods
     */
    openCreateModal() {
      const modal = document.querySelector('[data-create-modal]');
      const input = document.querySelector('[data-create-input]');
      const charCount = modal?.querySelector('[data-char-count]');

      if (modal) {
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      if (input) {
        input.value = '';
        if (charCount) charCount.textContent = '0/50';
        setTimeout(() => input.focus(), 100);
      }
    }

    closeCreateModal() {
      const modal = document.querySelector('[data-create-modal]');
      if (modal) {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }

    openRenameModal() {
      const manager = window.projectListManager;
      const activeList = manager?.getActiveList();
      if (!activeList) return;

      const modal = document.querySelector('[data-rename-modal]');
      const input = document.querySelector('[data-rename-input]');
      const charCount = modal?.querySelector('[data-char-count]');

      if (modal) {
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      if (input) {
        input.value = activeList.name;
        if (charCount) charCount.textContent = `${activeList.name.length}/50`;
        setTimeout(() => {
          input.focus();
          input.select();
        }, 100);
      }
    }

    closeRenameModal() {
      const modal = document.querySelector('[data-rename-modal]');
      if (modal) {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }

    openDeleteModal() {
      const manager = window.projectListManager;
      const activeList = manager?.getActiveList();
      if (!activeList) return;

      // Check if this is the last list - prevent deletion
      const allLists = manager.getAllLists();
      if (allLists && allLists.length <= 1) {
        alert('You are required to have at least one project list. Create a new list before deleting this one.');
        return;
      }

      const modal = document.querySelector('[data-delete-modal]');
      const listNameEl = document.querySelector('[data-delete-list-name]');

      if (modal) {
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      if (listNameEl) {
        listNameEl.textContent = `"${activeList.name}"`;
      }
    }

    closeDeleteModal() {
      const modal = document.querySelector('[data-delete-modal]');
      if (modal) {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }

    /**
     * Handle create list action
     */
    handleCreateList() {
      const manager = window.projectListManager;
      const input = document.querySelector('[data-create-input]');
      const name = input?.value?.trim();

      if (!name || !manager) return;

      const result = manager.createList(name);

      if (result.success) {
        this.closeCreateModal();
        this.renderListTabs();
        this.switchToList(result.list.id);
      } else {
        alert(result.error || 'Failed to create list');
      }
    }

    /**
     * Handle rename list action
     */
    handleRenameList() {
      const manager = window.projectListManager;
      const activeList = manager?.getActiveList();
      const input = document.querySelector('[data-rename-input]');
      const newName = input?.value?.trim();

      if (!newName || !manager || !activeList) return;

      const result = manager.renameList(activeList.id, newName);

      if (result.success) {
        this.closeRenameModal();
        this.renderListTabs();
      } else {
        alert(result.error || 'Failed to rename list');
      }
    }

    /**
     * Handle delete list action
     */
    handleDeleteList() {
      const manager = window.projectListManager;
      const activeList = manager?.getActiveList();

      if (!manager || !activeList) return;

      const result = manager.deleteList(activeList.id);

      if (result.success) {
        this.closeDeleteModal();
        // Will switch to new active list via event listener
      } else {
        alert(result.error || 'Failed to delete list');
      }
    }

    setDefaultLayout() {
      const defaultDesktopCol = parseInt(this.dataset.defaultDesktopCol);
      const maxCol = this.getMaxColOnSize();
      const defaultCol = (defaultDesktopCol <= maxCol) ? defaultDesktopCol : maxCol;

      const targetViewCol = this.viewCols.find(viewCol => parseInt(viewCol.dataset.col) === defaultCol );
      if (targetViewCol) {
        targetViewCol.click();
      }
    }

    async setProductForWishlistPage(handle, index, wishlistListLength) {
      try {
        // Prevent duplicates - check if product already exists in grid
        const existingProduct = this.gridViewContainer.querySelector(`[data-product-handle="${handle}"]`);
        if (existingProduct) {
          console.log(`[WishlistView] Product already in grid: ${handle}`);
          return;
        }

        const res = await fetch(`${window.routes.shop_origin}/products/${handle}?view=block_wishlist_card`);
        const data = await res.text();
        const parser = new DOMParser();

        const parsedDoc = parser.parseFromString(data, 'text/html');
        const productHTML = parsedDoc.querySelectorAll('#MainContent .card--block')[0];

        if (!productHTML) {
          console.warn(`[WishlistView] Product not found: ${handle}`);
          return;
        }

        this.gridViewContainer.appendChild(productHTML);
        productHTML.dataset.productHandle = handle;

        this.updateProductForWishlistPage();

        const item = this.wishlistContainer.querySelector(`.card--block[data-product-handle="${handle}"]`);

        if (item != null) {
          item.classList.add('wishlist-added');
          const textEl = item.querySelector('.text');
          if (textEl) textEl.textContent = window.wishlist?.added || 'Move / Delete From List';
          item.classList.add('is-in-grid');
          productHTML.dataset.wishlistAdded = `wishlist-${item.dataset.productId}`;

          // Add Remove from List button
          this.addRemoveButton(item, handle);
        }

      } catch (err) {
        console.error('[WishlistView] Error loading product:', err);
      }
    }

    updateProductForWishlistPage() {
      const sectionFetcher = document.querySelector('section-fetcher');

      if (sectionFetcher && typeof sectionFetcher.initialize === 'function') {
        sectionFetcher.initialize();
      } else {
        console.error('WishlistView: No section fetcher component found or initialize method not available');
      }
    }

    wishlistPagination() {
      const manager = window.projectListManager;
      const activeList = manager?.getActiveList();
      const productCount = activeList?.products?.length || 0;

      this.wishlistPaginateContainer.setAttribute('data-current-page', 1);
      while (this.wishlistPaginateContainer.firstChild) {
        this.wishlistPaginateContainer.removeChild(this.wishlistPaginateContainer.firstChild);
      }

      if (!this.gridViewContainer.classList.contains('productList')) return;
      this.gridViewContainer.classList.remove('is-loaded');

      this.totalPages = Math.ceil(productCount / 3);

      if (this.totalPages <= 1) {
        [...this.gridViewContainer.children].forEach(child => {
          child.style.display = 'block';
        });
        this.gridViewContainer.classList.add('is-loaded');
        return;
      }

      this.gridViewContainer.classList.add('is-loaded');
    }

    removeItemFromWishlistPage(handle, productId) {
      let productElement = null;

      if (handle) {
        productElement = this.gridViewContainer.querySelector(`[data-product-handle="${handle}"]`);
      }

      if (!productElement && productId) {
        productElement = this.gridViewContainer.querySelector(`[data-wishlist-added="wishlist-${productId}"]`);
      }

      if (productElement) {
        productElement.remove();
      }

      // Check if list is now empty
      const manager = window.projectListManager;
      const activeList = manager?.getActiveList();
      const remainingItems = this.gridViewContainer.querySelectorAll('[data-product-handle]');

      if (!activeList || activeList.products.length === 0 || remainingItems.length === 0) {
        this.showEmptyState('empty-list');
      } else {
        this.wishlistPagination();
        this.updateShareWishlistViaMail();

        if (this.gridViewContainer.classList.contains('productList')) {
          this.paginationForList(true);
        }
      }
    }

    /**
     * Add a remove button, quantity input, and Add to Cart to a product card on the wishlist page
     * @param {HTMLElement} item - The product card element
     * @param {string} handle - The product handle
     */
    addRemoveButton(item, handle) {
      if (!item || !handle) return;

      // Check if already added
      if (item.querySelector('.project-list-card-actions')) return;

      const manager = window.projectListManager;
      const currentQuantity = manager ? manager.getQuantity(this.activeListId, handle) : 1;

      // Get variant ID from the item
      const variantId = item.dataset.variantId || item.querySelector('[data-variant-id]')?.dataset.variantId || null;

      // Create actions wrapper
      const actionsWrapper = document.createElement('div');
      actionsWrapper.className = 'project-list-card-actions';

      // Create Quantity + Add to Cart section
      const addToCartSection = document.createElement('div');
      addToCartSection.className = 'project-list-add-to-cart-section';
      addToCartSection.innerHTML = `
        <div class="project-list-cart-quantity">
          <label class="project-list-cart-quantity-label" for="cart-qty-${handle}">
            ${window.projectList?.quantity || 'Quantity'}
          </label>
          <div class="project-list-cart-quantity-wrapper">
            <button type="button" class="project-list-cart-qty-btn project-list-cart-qty-btn--minus" data-cart-qty-decrease aria-label="${window.projectList?.decrease_quantity || 'Decrease quantity'}">
              <svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" width="12" height="12">
                <path d="M4 10h12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
            <input
              type="number"
              id="cart-qty-${handle}"
              class="project-list-cart-quantity-input"
              value="${currentQuantity}"
              min="1"
              max="9999"
              data-cart-quantity-input
              data-handle="${handle}"
              aria-label="${window.projectList?.quantity_to_add || 'Quantity to add to cart'}"
            >
            <button type="button" class="project-list-cart-qty-btn project-list-cart-qty-btn--plus" data-cart-qty-increase aria-label="${window.projectList?.increase_quantity || 'Increase quantity'}">
              <svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" width="12" height="12">
                <path d="M10 4v12M4 10h12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </div>
        <button
          type="button"
          class="project-list-add-to-cart-btn"
          data-add-to-cart-btn
          data-handle="${handle}"
          data-variant-id="${variantId || ''}"
          aria-label="${window.projectList?.add_to_cart || 'Add to cart'}"
        >
          <svg class="project-list-add-to-cart-btn__icon" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16">
            <path d="M1 1h2.5l.5 2h13l-1.5 7H5.5L4 3H1V1zm4.5 15a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm9 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" fill="currentColor"/>
          </svg>
          <span class="project-list-add-to-cart-btn__text">${window.projectList?.add_to_cart || 'Add to Cart'}</span>
          <span class="project-list-add-to-cart-btn__added-text">${window.projectList?.added_to_cart || 'Added!'}</span>
          <span class="project-list-add-to-cart-btn__spinner">
            <svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" width="16" height="16">
              <circle cx="10" cy="10" r="8" fill="none" stroke="currentColor" stroke-width="2" stroke-dasharray="50" stroke-dashoffset="25"/>
            </svg>
          </span>
        </button>
      `;

      // Bind Add to Cart quantity events
      const cartQuantityInput = addToCartSection.querySelector('[data-cart-quantity-input]');
      const cartDecreaseBtn = addToCartSection.querySelector('[data-cart-qty-decrease]');
      const cartIncreaseBtn = addToCartSection.querySelector('[data-cart-qty-increase]');
      const addToCartBtn = addToCartSection.querySelector('[data-add-to-cart-btn]');

      cartDecreaseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const currentVal = parseInt(cartQuantityInput.value) || 1;
        const newVal = Math.max(1, currentVal - 1);
        cartQuantityInput.value = newVal;
        this.handleQuantityChange(handle, newVal);
      });

      cartIncreaseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const currentVal = parseInt(cartQuantityInput.value) || 1;
        const newVal = Math.min(9999, currentVal + 1);
        cartQuantityInput.value = newVal;
        this.handleQuantityChange(handle, newVal);
      });

      cartQuantityInput.addEventListener('change', (e) => {
        const newVal = Math.max(1, Math.min(9999, parseInt(e.target.value) || 1));
        e.target.value = newVal;
        this.handleQuantityChange(handle, newVal);
      });

      // Bind Add to Cart button event
      addToCartBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const quantity = parseInt(cartQuantityInput.value) || 1;
        this.handleAddToCart(handle, addToCartBtn, item, quantity);
      });

      // Create the remove button
      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'project-list-remove-btn';
      removeBtn.setAttribute('aria-label', window.projectList?.remove_from_list || 'Remove from list');
      removeBtn.setAttribute('title', window.projectList?.remove_from_list || 'Remove from list');
      removeBtn.dataset.productHandle = handle;

      removeBtn.innerHTML = `
        <svg class="project-list-remove-btn__icon" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16">
          <path d="M8.5 4a1.5 1.5 0 013 0v.5h3a1 1 0 110 2h-.554l-.675 9.342A2 2 0 0111.28 17.5H8.72a2 2 0 01-1.991-1.658L6.054 6.5H5.5a1 1 0 010-2h3V4zm1.5-.5a.5.5 0 00-.5.5v.5h1V4a.5.5 0 00-.5-.5zm-2.446 3l.654 9.057a1 1 0 001 .943h1.584a1 1 0 001-.943L12.446 6.5H7.554z" fill="currentColor"/>
        </svg>
        <span class="project-list-remove-btn__text">${window.projectList?.remove_from_list || 'Remove From List'}</span>
      `;

      removeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.handleRemoveItem(handle, removeBtn);
      });

      // Assemble actions wrapper
      actionsWrapper.appendChild(addToCartSection);
      actionsWrapper.appendChild(removeBtn);

      // Find the best place to insert - after the product information (NOT inside the image area)
      // Priority: .card-information (Ella flex cards) > .card__information > .card-product__content > card itself
      const cardInformation = item.querySelector('.card-information') ||
                              item.querySelector('.card-information__wrapper') ||
                              item.querySelector('.card__information') ||
                              item.querySelector('.card-product__content');

      if (cardInformation) {
        cardInformation.appendChild(actionsWrapper);
      } else {
        // Fallback: append to card but after all existing content
        const card = item.querySelector('.card') || item.querySelector('.card-wrapper') || item;
        card.appendChild(actionsWrapper);
      }
    }

    /**
     * Handle add to cart action
     * @param {string} handle - Product handle
     * @param {HTMLElement} button - The add to cart button
     * @param {HTMLElement} item - The product card element
     * @param {number} quantity - Quantity to add
     */
    async handleAddToCart(handle, button, item, quantity = 1) {
      // Get variant ID - try multiple sources
      let variantId = button.dataset.variantId;

      if (!variantId || variantId === '') {
        variantId = item.dataset.variantId ||
                    item.querySelector('[data-variant-id]')?.dataset.variantId ||
                    item.querySelector('.product-variant-id')?.value ||
                    item.querySelector('input[name="id"]')?.value;
      }

      if (!variantId) {
        // If still no variant ID, fetch it from the product
        try {
          const response = await fetch(`/products/${handle}.js`);
          if (response.ok) {
            const productData = await response.json();
            variantId = productData.variants[0]?.id;
          }
        } catch (err) {
          console.error('[WishlistView] Failed to fetch product data:', err);
        }
      }

      if (!variantId) {
        console.error('[WishlistView] Cannot add to cart: no variant ID found');
        this.showAddToCartError(button, window.projectList?.variant_required || 'Please select a variant');
        return;
      }

      // Set loading state
      button.classList.add('is-loading');
      button.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: parseInt(variantId),
            quantity: quantity
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Failed to add to cart');
        }

        // Success - show added state
        button.classList.remove('is-loading');
        button.classList.add('is-added');

        // Update cart count in header
        this.updateCartCount();

        // Dispatch cart updated event
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { item: data }
        }));

        // Reset button after delay
        setTimeout(() => {
          button.classList.remove('is-added');
          button.disabled = false;
        }, 2000);

      } catch (error) {
        console.error('[WishlistView] Add to cart error:', error);
        button.classList.remove('is-loading');
        button.disabled = false;
        this.showAddToCartError(button, error.message);
      }
    }

    /**
     * Show error message for add to cart
     * @param {HTMLElement} button - The button element
     * @param {string} message - Error message
     */
    showAddToCartError(button, message) {
      // Create or update error tooltip
      let tooltip = button.parentElement.querySelector('.project-list-cart-error');
      if (!tooltip) {
        tooltip = document.createElement('div');
        tooltip.className = 'project-list-cart-error';
        button.parentElement.appendChild(tooltip);
      }
      tooltip.textContent = message;
      tooltip.classList.add('is-visible');

      // Hide after delay
      setTimeout(() => {
        tooltip.classList.remove('is-visible');
      }, 3000);
    }

    /**
     * Update cart count in header
     */
    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        if (response.ok) {
          const cart = await response.json();
          const countElements = document.querySelectorAll('.cart-count-bubble, [data-cart-count], .header-cart-count');
          countElements.forEach(el => {
            if (el.classList.contains('cart-count-bubble')) {
              el.textContent = cart.item_count;
              el.style.display = cart.item_count > 0 ? '' : 'none';
            } else {
              el.textContent = cart.item_count;
            }
          });
        }
      } catch (err) {
        console.error('[WishlistView] Failed to update cart count:', err);
      }
    }

    /**
     * Handle quantity change for a product
     * @param {string} handle - Product handle
     * @param {number|string} value - New quantity value
     */
    handleQuantityChange(handle, value) {
      const manager = window.projectListManager;
      if (!manager || !this.activeListId) {
        console.error('[WishlistView] Cannot update quantity: missing manager or active list');
        return;
      }

      const qty = Math.max(1, Math.min(9999, parseInt(value) || 1));
      const result = manager.setQuantity(this.activeListId, handle, qty);

      if (!result.success) {
        console.error('[WishlistView] Failed to update quantity:', result.error);
      }
    }

    /**
     * Handle removing an item from the list
     * @param {string} handle - The product handle to remove
     * @param {HTMLElement} button - The button element (for loading state)
     */
    handleRemoveItem(handle, button) {
      const manager = window.projectListManager;
      if (!manager || !this.activeListId) {
        console.error('[WishlistView] Cannot remove item: missing manager or active list');
        return;
      }

      // Add loading state
      button.classList.add('is-loading');
      button.disabled = true;

      // Remove from the list via manager
      const result = manager.removeFromList(this.activeListId, handle);

      if (result.success) {
        // Remove from UI immediately
        this.removeItemFromWishlistPage(handle);

        // Update tab counts
        this.renderListTabs();

        // Dispatch event for any other listeners
        document.dispatchEvent(new CustomEvent('projectlist:product-removed', {
          detail: {
            listId: this.activeListId,
            handle: handle
          }
        }));
      } else {
        // Remove loading state on error
        button.classList.remove('is-loading');
        button.disabled = false;
        console.error('[WishlistView] Failed to remove item:', result.error);
      }
    }

    paginateToPages(nextPageNumber = null) {
      const children = [...this.gridViewContainer.children];

      if (nextPageNumber == null) {
        children.forEach((element, index) => {
          if (index >= 3) {
            element.style.display = 'none';
          }
          else {
            element.style.display = 'block';
          }
        });
        return;
      }

      children.forEach((element, index) => {
        if (index >= (nextPageNumber - 1) * 3 && index < nextPageNumber * 3) {
          element.style.display = 'block';
        }
        else {
          element.style.display = 'none';
        }
      });

      if (nextPageNumber === 1) {
        this.wishlistPaginateContainer.querySelector('.prev').classList.add('disabled');
        this.wishlistPaginateContainer.querySelector('.next').classList.remove('disabled');
      }
      else if (nextPageNumber === this.totalPages) {
        this.wishlistPaginateContainer.querySelector('.next').classList.add('disabled');
        this.wishlistPaginateContainer.querySelector('.prev').classList.remove('disabled');
      }
      else {
        this.wishlistPaginateContainer.querySelector('.prev').classList.remove('disabled');
        this.wishlistPaginateContainer.querySelector('.next').classList.remove('disabled');
      }
    }

    removeAndAddPaginationButtonEvents() {
      const container = this.wishlistPaginateContainer;
      const newContainer = container.cloneNode(true);
      container.parentNode.replaceChild(newContainer, container);
      this.wishlistPaginateContainer = newContainer;

      this.wishlistPaginateContainer.addEventListener('click', (event) => {
        const link = event.target.closest('li a');
        if (!link) return;

        event.preventDefault();
        const li = link.parentElement;
        const isPrev = li.classList.contains('prev');
        const isNext = li.classList.contains('next');
        let pageNumber = parseInt(link.dataset.page);

        const currentButton = this.wishlistPaginateContainer.querySelector('.active');
        let curPage = currentButton ? parseInt(currentButton.querySelector('.link').dataset.page) : 1;

        if (isPrev) {
          pageNumber = curPage - 1;
          if (pageNumber <= 0) pageNumber = 1;
        }

        if (isNext) {
          pageNumber = curPage + 1;
          if (pageNumber > this.totalPages) pageNumber = this.totalPages;
        }

        this.wishlistPaginateContainer.dataset.currentPage = pageNumber;
        this.paginateToPages(pageNumber);

        if (currentButton) {
          currentButton.classList.remove('active');
        }
        const newActive = this.wishlistPaginateContainer.querySelector(`[data-page="${pageNumber}"]`);
        if (newActive && newActive.parentElement) {
          newActive.parentElement.classList.add('active');
        }
      });
    }

    /**
     * Update share link to include only current list's products
     */
    updateShareWishlistViaMail() {
      const manager = window.projectListManager;
      const activeList = manager?.getActiveList();

      const regex = /(<([^>]+)>)/ig;
      const addedItems = document.querySelectorAll('[data-wishlist-added]');

      const shareLinkElement = document.querySelector('[data-wishlist-share]');
      if (!shareLinkElement) return;

      const listName = activeList?.name || 'Project List';
      let href = `mailto:?subject= ${encodeURIComponent(listName)}&body=`;

      addedItems.forEach((item, index) => {
        const price = item.querySelector('.price__sale .price__last .price-item')?.textContent || item.querySelector('.price__regular .price__last .price-item')?.textContent;
        const title = item.querySelector('[data-product-title]')?.dataset.productTitle;
        const url = item.querySelector('[data-product-url]')?.dataset.productUrl;

        if (title && url) {
          href += encodeURIComponent(title + '\nPrice: ' + (price?.replace(regex, '') || 'N/A') + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + url +'\n\n');
        }
      });

      shareLinkElement.href = href;
    }

    /* ========================================================================
       EXPORT METHODS
       ======================================================================== */

    /**
     * Gather product data from the current list for export
     * @returns {Promise<Array>} Array of product objects with title, price, quantity, image, url
     */
    async gatherExportData() {
      const manager = window.projectListManager;
      const activeList = manager?.getActiveList();
      if (!activeList) return [];

      const addedItems = document.querySelectorAll('[data-wishlist-added]');
      const products = [];
      const regex = /(<([^>]+)>)/ig;

      addedItems.forEach((item) => {
        const handle = item.dataset.productHandle;
        const title = item.querySelector('[data-product-title]')?.dataset.productTitle || 'Unknown Product';

        // More robust price extraction - try multiple selectors
        let priceEl = item.querySelector('.price__sale .price__last .price-item') ||
                      item.querySelector('.price__regular .price__last .price-item') ||
                      item.querySelector('.price-item--sale') ||
                      item.querySelector('.price-item--regular') ||
                      item.querySelector('.price__regular .price-item') ||
                      item.querySelector('.price .price-item') ||
                      item.querySelector('.price__current') ||
                      item.querySelector('[data-product-price]') ||
                      item.querySelector('.card-product__price') ||
                      item.querySelector('.money');

        const price = priceEl?.textContent?.replace(regex, '').trim() || '$0.00';
        const url = item.querySelector('[data-product-url]')?.dataset.productUrl || '';
        const imageEl = item.querySelector('img');
        const image = imageEl?.src || '';

        // Get quantity from the cart quantity input field on the card
        const quantityInput = item.querySelector('[data-cart-quantity-input]');
        const quantity = parseInt(quantityInput?.value) || 1;

        // Parse price to number for calculations
        const priceNum = parseFloat(price.replace(/[^0-9.]/g, '')) || 0;

        products.push({
          handle,
          title,
          price,
          priceNum,
          quantity,
          total: (priceNum * quantity).toFixed(2),
          url: window.location.protocol + '//' + window.location.hostname + url,
          image
        });
      });

      return products;
    }

    /**
     * Export to PDF - Opens a print-friendly view
     */
    async exportToPDF() {
      const manager = window.projectListManager;
      const activeList = manager?.getActiveList();
      if (!activeList) {
        alert(window.projectList?.no_items_to_export || 'No items to export');
        return;
      }

      const products = await this.gatherExportData();
      if (products.length === 0) {
        alert(window.projectList?.no_items_to_export || 'No items to export');
        return;
      }

      // Calculate grand total
      const grandTotal = products.reduce((sum, p) => sum + (p.priceNum * p.quantity), 0).toFixed(2);
      const currencySymbol = products[0]?.price?.match(/[^0-9.,]/)?.[0] || '$';

      // Create print window content
      const printContent = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>${activeList.name} - Packing List</title>
          <style>
            * { box-sizing: border-box; margin: 0; padding: 0; }
            body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; padding: 40px; color: #333; }
            .header { margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 20px; }
            .header h1 { font-size: 24px; margin-bottom: 5px; }
            .header .date { color: #666; font-size: 14px; }
            .header .store { color: #666; font-size: 14px; margin-top: 5px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th { background: #f5f5f5; padding: 12px 8px; text-align: left; font-weight: 600; border-bottom: 2px solid #ddd; }
            td { padding: 12px 8px; border-bottom: 1px solid #eee; vertical-align: middle; }
            .product-image { width: 60px; height: 60px; object-fit: cover; border: 1px solid #eee; border-radius: 4px; }
            .product-title { font-weight: 500; }
            .text-right { text-align: right; }
            .text-center { text-align: center; }
            .grand-total { margin-top: 20px; text-align: right; font-size: 18px; font-weight: 600; padding: 15px 0; border-top: 2px solid #333; }
            .footer { margin-top: 40px; padding-top: 20px; border-top: 1px solid #eee; font-size: 12px; color: #666; }
            @media print {
              body { padding: 20px; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>${this.escapeHtml(activeList.name)}</h1>
            <div class="date">Generated: ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
            <div class="store">${window.location.hostname}</div>
          </div>
          <table>
            <thead>
              <tr>
                <th style="width: 70px;">Image</th>
                <th>Product</th>
                <th class="text-center" style="width: 80px;">Qty</th>
                <th class="text-right" style="width: 100px;">Unit Price</th>
                <th class="text-right" style="width: 100px;">Total</th>
              </tr>
            </thead>
            <tbody>
              ${products.map(p => `
                <tr>
                  <td>${p.image ? `<img class="product-image" src="${p.image}" alt="">` : '-'}</td>
                  <td class="product-title">${this.escapeHtml(p.title)}</td>
                  <td class="text-center">${p.quantity}</td>
                  <td class="text-right">${p.price}</td>
                  <td class="text-right">${currencySymbol}${p.total}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          <div class="grand-total">Grand Total: ${currencySymbol}${grandTotal}</div>
          <div class="footer">
            <p>This packing list was generated from ${window.location.hostname}</p>
          </div>
        </body>
        </html>
      `;

      // Create a hidden iframe for printing (same page, no new tab)
      let printFrame = document.getElementById('project-list-print-frame');
      if (!printFrame) {
        printFrame = document.createElement('iframe');
        printFrame.id = 'project-list-print-frame';
        printFrame.name = 'project-list-print-frame';
        printFrame.style.position = 'absolute';
        printFrame.style.top = '-9999px';
        printFrame.style.left = '-9999px';
        printFrame.style.width = '0';
        printFrame.style.height = '0';
        printFrame.style.border = 'none';
        document.body.appendChild(printFrame);
      }

      // Write content to iframe and print
      const frameDoc = printFrame.contentWindow || printFrame.contentDocument;
      const doc = frameDoc.document || frameDoc;
      doc.open();
      doc.write(printContent);
      doc.close();

      // Wait for content to load, then print
      setTimeout(() => {
        printFrame.contentWindow.focus();
        printFrame.contentWindow.print();
      }, 250);
    }

    /**
     * Export to CSV - Downloads a CSV file
     */
    async exportToCSV() {
      const manager = window.projectListManager;
      const activeList = manager?.getActiveList();
      if (!activeList) {
        alert(window.projectList?.no_items_to_export || 'No items to export');
        return;
      }

      const products = await this.gatherExportData();
      if (products.length === 0) {
        alert(window.projectList?.no_items_to_export || 'No items to export');
        return;
      }

      // Calculate grand total
      const grandTotal = products.reduce((sum, p) => sum + (p.priceNum * p.quantity), 0).toFixed(2);

      // Build CSV content
      const headers = ['Product Title', 'Quantity', 'Unit Price', 'Line Total', 'Product URL'];
      const rows = products.map(p => [
        this.escapeCSV(p.title),
        p.quantity,
        p.price,
        '$' + p.total,
        p.url
      ]);

      // Add grand total row
      rows.push(['', '', '', '', '']);
      rows.push(['GRAND TOTAL', '', '', '$' + grandTotal, '']);

      const csvContent = [
        `Project Name: ${this.escapeCSV(activeList.name)}`,
        `Generated: ${new Date().toLocaleDateString()}`,
        '',
        headers.join(','),
        ...rows.map(row => row.join(','))
      ].join('\n');

      // Create and download file
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${this.slugify(activeList.name)}-packing-list.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }

    /**
     * Export to Email - Opens email client with formatted content
     */
    async exportToEmail() {
      const manager = window.projectListManager;
      const activeList = manager?.getActiveList();
      if (!activeList) {
        alert(window.projectList?.no_items_to_export || 'No items to export');
        return;
      }

      const products = await this.gatherExportData();
      if (products.length === 0) {
        alert(window.projectList?.no_items_to_export || 'No items to export');
        return;
      }

      // Calculate grand total
      const grandTotal = products.reduce((sum, p) => sum + (p.priceNum * p.quantity), 0).toFixed(2);
      const currencySymbol = products[0]?.price?.match(/[^0-9.,]/)?.[0] || '$';

      // Build email body
      const subject = encodeURIComponent(`${activeList.name} - Packing List`);
      let body = `Project: ${activeList.name}\n`;
      body += `Generated: ${new Date().toLocaleDateString()}\n`;
      body += `\n${'='.repeat(50)}\n\n`;

      products.forEach((p, i) => {
        body += `${i + 1}. ${p.title}\n`;
        body += `   Quantity: ${p.quantity}\n`;
        body += `   Unit Price: ${p.price}\n`;
        body += `   Line Total: ${currencySymbol}${p.total}\n`;
        body += `   Link: ${p.url}\n\n`;
      });

      body += `${'='.repeat(50)}\n`;
      body += `GRAND TOTAL: ${currencySymbol}${grandTotal}\n`;
      body += `\n---\nGenerated from ${window.location.hostname}`;

      // Open mailto link
      window.location.href = `mailto:?subject=${subject}&body=${encodeURIComponent(body)}`;
    }

    /**
     * Add all items from the current list to the cart
     * Uses the quantities set in each product card's quantity input
     */
    async addAllToCart() {
      const manager = window.projectListManager;
      const activeList = manager?.getActiveList();
      const addAllBtn = document.querySelector('[data-add-all-to-cart]');

      if (!activeList || activeList.products.length === 0) {
        alert(window.projectList?.no_items_to_add || 'No items to add to cart');
        return;
      }

      // Get all product cards in the current view
      const productCards = this.gridViewContainer.querySelectorAll('[data-product-handle]');
      if (productCards.length === 0) {
        alert(window.projectList?.no_items_to_add || 'No items to add to cart');
        return;
      }

      // Set loading state on button
      if (addAllBtn) {
        addAllBtn.classList.add('is-loading');
        addAllBtn.disabled = true;
      }

      // Gather all items with their quantities and variant IDs
      const itemsToAdd = [];

      for (const card of productCards) {
        const handle = card.dataset.productHandle;
        if (!handle) continue;

        // Get quantity from the cart quantity input on this card
        const quantityInput = card.querySelector('[data-cart-quantity-input]');
        const quantity = parseInt(quantityInput?.value) || 1;

        // Get variant ID - try multiple sources
        let variantId = card.dataset.variantId ||
                        card.querySelector('[data-variant-id]')?.dataset.variantId ||
                        card.querySelector('[data-add-to-cart-btn]')?.dataset.variantId ||
                        card.querySelector('.product-variant-id')?.value ||
                        card.querySelector('input[name="id"]')?.value;

        // If no variant ID, fetch it from the product
        if (!variantId) {
          try {
            const response = await fetch(`/products/${handle}.js`);
            if (response.ok) {
              const productData = await response.json();
              variantId = productData.variants[0]?.id;
            }
          } catch (err) {
            console.error(`[WishlistView] Failed to fetch variant for ${handle}:`, err);
          }
        }

        if (variantId) {
          itemsToAdd.push({
            id: parseInt(variantId),
            quantity: quantity
          });
        }
      }

      if (itemsToAdd.length === 0) {
        if (addAllBtn) {
          addAllBtn.classList.remove('is-loading');
          addAllBtn.disabled = false;
        }
        alert(window.projectList?.no_valid_items || 'No valid items found to add to cart');
        return;
      }

      try {
        // Use Shopify's cart/add.js with items array for bulk add
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: itemsToAdd
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Failed to add items to cart');
        }

        // Success - show success state
        if (addAllBtn) {
          addAllBtn.classList.remove('is-loading');
          addAllBtn.classList.add('is-success');
        }

        // Update cart count in header
        this.updateCartCount();

        // Dispatch cart updated event
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { items: data.items || data }
        }));

        // Reset button after delay
        setTimeout(() => {
          if (addAllBtn) {
            addAllBtn.classList.remove('is-success');
            addAllBtn.disabled = false;
          }
        }, 2500);

      } catch (error) {
        console.error('[WishlistView] Add all to cart error:', error);
        if (addAllBtn) {
          addAllBtn.classList.remove('is-loading');
          addAllBtn.disabled = false;
        }
        alert(error.message || window.projectList?.add_all_error || 'Failed to add items to cart');
      }
    }

    /**
     * Escape HTML special characters
     * @param {string} str - String to escape
     * @returns {string} Escaped string
     */
    escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    /**
     * Escape CSV special characters
     * @param {string} str - String to escape
     * @returns {string} Escaped string
     */
    escapeCSV(str) {
      if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return '"' + str.replace(/"/g, '""') + '"';
      }
      return str;
    }

    /**
     * Convert string to URL-friendly slug
     * @param {string} str - String to slugify
     * @returns {string} Slugified string
     */
    slugify(str) {
      return str
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .trim();
    }
  }
  if (!customElements.get('wishlist-view')) customElements.define('wishlist-view', WishlistView);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-product-tabs-section]').forEach(function(productTabs) {
      const tabTitles = productTabs.querySelectorAll('.product-tabs-tab > .tabs-list .tab-title');
      const tabContents = productTabs.querySelectorAll('.product-tabs-tab > .tabs-content > .tab-content');

      if (!tabTitles.length || tabTitles.length !== tabContents.length) return;

      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        const variantId = event?.data?.variant?.id;
        if (!variantId) return;

        document.querySelectorAll('[data-product-tabs-section][data-product-url]').forEach(function(productTabs) {
          updateProductSpecifications(productTabs, variantId);
        });
      });
    }

    async function updateProductSpecifications(productTabs, variantId) {
      const sectionId = productTabs.dataset.productTabsSection;
      const productUrl = productTabs.dataset.productUrl;
      if (!sectionId || !productUrl) return;

      const requestUrl = new URL(productUrl, window.location.origin);
      requestUrl.searchParams.set('variant', variantId);
      requestUrl.searchParams.set('section_id', sectionId);

      try {
        const response = await fetch(requestUrl.toString());
        if (!response.ok) return;

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextTabs = html.querySelector(`[data-product-tabs-section="${CSS.escape(sectionId)}"]`);
        if (!nextTabs) return;

        productTabs.querySelectorAll('[data-product-specifications-panel]').forEach(function(currentPanel) {
          const blockId = currentPanel.dataset.productSpecificationsPanel;
          const selector = `[data-product-specifications-panel="${CSS.escape(blockId)}"]`;
          const nextPanel = nextTabs.querySelector(selector);
          if (!nextPanel) return;

          const currentContent = currentPanel.querySelector(':scope > .toggle-content');
          const nextContent = nextPanel.querySelector(':scope > .toggle-content');
          if (currentContent && nextContent) currentContent.innerHTML = nextContent.innerHTML;

          currentPanel.hidden = nextPanel.hidden;
          const triggerSelector = `[data-product-specifications-trigger="${CSS.escape(blockId)}"]`;
          const currentTrigger = productTabs.querySelector(triggerSelector);
          const nextTrigger = nextTabs.querySelector(triggerSelector);
          if (currentTrigger && nextTrigger) currentTrigger.hidden = nextTrigger.hidden;
        });

        activateFirstAvailableTab(productTabs);
      } catch (error) {
        return;
      }
    }

    function activateFirstAvailableTab(productTabs) {
      if (!productTabs.querySelector('.tabs-list')) return;

      const activeTitle = productTabs.querySelector('.tabs-item:not([hidden]) .tab-title.is-active');
      if (activeTitle) return;

      productTabs.querySelectorAll('.tabs-item > .tab-title, .product-tabs-tab > .tabs-content > .tab-content').forEach(function(element) {
        element.classList.remove('is-active');
      });

      const firstTitle = productTabs.querySelector('.tabs-item:not([hidden]) .tab-title');
      if (!firstTitle) return;

      firstTitle.classList.add('is-active');
      const target = productTabs.querySelector(firstTitle.getAttribute('href'));
      if (target && !target.hidden) target.classList.add('is-active');
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
